import getSymbolFromCurrency from 'currency-map-symbol';
import {mapGetters, mapState} from 'vuex';

export const formatMixin = {
  computed: {
    ...mapState('user', ['defaultCurrency']),
    ...mapGetters('user', ['getLocaleIso']),
    stringToHslColor() {
      return (str, s, l) => {
        let hash = 0;
        /* eslint-disable */
        const string = str ? str : '';
        for (let i = 0; i < string.length; i += 1) {
          hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }
        /* eslint-enable */
        const h = hash % 360;
        return `hsl(${h}, ${s}%, ${l}%)`;
      };
    },
    nameToSlug() {
      return (name, count = 3) => {
        const wordArray = name.split(' ');
        let slug = '';
        if (wordArray.length === 1) {
          slug = wordArray[0].slice(0, 2);
        } else if (wordArray.length === 2) {
          slug = wordArray[0].slice(0, 1);
          slug += wordArray[1][0];
        } else {
          wordArray.forEach((word) => {
            if (slug.length < count) {
              slug += word[0];
            }
          });
        }
        return slug;
      };
    },
    displayedCompanies() {
      return (obj) =>
        Object.entries(obj).sort((a, b) => {
          if (
            (a[1][0] ? a[1][0] : '').toLowerCase() >
            (b[1][0] ? b[1][0] : '').toLowerCase()
          ) {
            return 1;
          }
          if (
            (a[1][0] ? a[1][0] : '').toLowerCase() <
            (b[1][0] ? b[1][0] : '').toLowerCase()
          ) {
            return -1;
          }
          return 0;
        });
    },
    formatCurrencyInteger() {
      return (val) => {
        if (!isNaN(val)) {
          return new Intl.NumberFormat(this.getLocaleIso).format(val);
        }
        return val;
      };
    },
    numberValueDecimal() {
      return (val) => (isNaN(Number(val)) || !val ? null : Number(val));
    },
    formatCurrencyFlexible() {
      return (val, maxAmount) =>
        Math.abs(+val) > maxAmount
          ? this.getValueWithCurrency(val).replace(/[^\d.,\s-]+/g, '')
          : this.getValueWithCurrency(val);
    },
    formatCurrencyIntegerWithDefaultCurrency() {
      // eslint-disable-next-line no-unused-vars
      return (val, currency = this.defaultCurrency) =>
        this.formatCurrency(val, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
          currency,
        });
    },
    formatCurrencyWithDecimal() {
      return (val, cur) =>
        this.formatCurrency(val, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          currency: cur || this.defaultCurrency,
        });
    },
    formatCurrencyCompact() {
      return (val, currency = this.defaultCurrency) =>
        this.formatCurrency(val, {
          notation: 'compact',
          compactDisplay: 'short',
          currency,
        });
    },
    formatCurrency() {
      return (
        value,
        {
          currency = this.defaultCurrency,
          minimumFractionDigits = 0,
          maximumFractionDigits = 0,
          notation = 'standard',
          compactDisplay = 'long',
        } = {
          currency: this.defaultCurrency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        },
      ) =>
        new Intl.NumberFormat(this.getLocaleIso, {
          minimumFractionDigits,
          maximumFractionDigits,
          style: 'currency',
          currency,
          notation,
          compactDisplay,
        }).format(value);
    },
    getSymbol() {
      return (cur) => getSymbolFromCurrency(cur);
    },
    normalize() {
      return (txt) =>
        txt
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();
    },
    stringInclude() {
      return (a, b) => this.normalize(a).includes(this.normalize(b));
    },
    solde() {
      return (banks) => {
        if (banks && banks.length) {
          const total = banks.reduce((acc, el) => {
            const val = el.accounts.reduce(
              (accum, a) =>
                (a.balance ? a.balance : 0) / a.exchange_rate + accum,
              0,
            );
            return val + acc;
          }, 0);
          return total;
        }
        return 0;
      };
    },
  },
  methods: {
    getSeparators() {
      const parts = new Intl.NumberFormat(this.getLocaleIso).formatToParts(1.2);
      return parts.find((p) => p.type === 'decimal')?.value || '.';
    },
    replaceSeparators(raw) {
      const decimal = this.getSeparators();
      let s = String(raw ?? '').replace(/\s|\u00A0/g, '');

      // keep only first [.,] as decimal, remove all other separators
      const firstSep = s.search(/[.,]/);
      if (firstSep !== -1) {
        const int = s.slice(0, firstSep).replace(/[.,]/g, '');
        let frac = s.slice(firstSep + 1).replace(/[.,]/g, '');
        //  Limit fractional part to max 2 digits
        frac = frac.slice(0, 2);
        s = int + decimal + frac;
      } else {
        s = s.replace(/[.,]/g, '');
      }
      s = s.replace(/(?!^)-/g, '').replace(/[^0-9\-,.]/g, '');
      return s;
    },
  },
};

export default {formatMixin};
